<template>
  <div class="wrapper_group_dashboard ticket-manage-wrapper">
    <div class="group_dashboard">
      <div class="admin_message_wrapper">
        <div class="breadcrumbwrapper d-flex justify-content-between align-items-center flex-wrap pb-2">
        <breadcrumb :items="breadcrumbItems" />
        <button class="btn univ-btn  mt-0 d-inline-flex align-items-center justify-content-center fw-medium"
          @click="openModal('AddTicketModal')">
          <span class="icon-wrapper d-flex align-items-center justify-content-center fw-medium"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M19 12.998h-6v6h-2v-6H5v-2h6v-6h2v6h6z"/></svg></span>
          Add Ticket
         </button>
        </div>
        <div class="row mt-4">
        <div class="col-lg-3 col-sm-6 mb-3">
          <div class="ticket_card total-issue-card d-flex align-items-center gap-3 h-100">
            <div class="iconwrapper d-flex align-items-center justify-content-center flex-shrink-0">
              <b-skeleton v-if="isStatsSkeleton" type="circle" width="46px" height="46px" class="rounded-circle"></b-skeleton>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="currentColor" fill-rule="evenodd"
                  d="M20 4H4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1M4 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm2 5h2v2H6zm5 0a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm-3 4H6v2h2zm2 1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m-2 3H6v2h2zm2 1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <div class="contentwrapper">
              <div class="content-title">
                <b-skeleton v-if="isStatsSkeleton" type="text" width="100px"></b-skeleton>
                <span v-else>Total Issues</span>
              </div>
              <div class="issueCount clr-title font-weight-bold">
                <b-skeleton v-if="isStatsSkeleton" type="text" width="50px"></b-skeleton>
                <span v-else>{{ totalIssues }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6 mb-3">
          <div class="ticket_card active-issue-card d-flex align-items-center gap-3 h-100">
            <div class="iconwrapper d-flex align-items-center justify-content-center flex-shrink-0">
              <b-skeleton v-if="isStatsSkeleton" type="circle" width="46px" height="46px" class="rounded-circle"></b-skeleton>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g fill="none" fill-rule="evenodd">
                  <path
                    d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z" />
                  <path fill="currentColor"
                    d="M5 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7.17a3.001 3.001 0 0 1 5.66 0H19a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1.17a3.001 3.001 0 0 1-5.66 0zM2 7a3 3 0 0 1 3-3h8a1 1 0 0 1 1 1a1 1 0 1 0 2 0a1 1 0 0 1 1-1h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-2a1 1 0 0 1-1-1a1 1 0 1 0-2 0a1 1 0 0 1-1 1H5a3 3 0 0 1-3-3zm13 2a1 1 0 0 1 1 1v.5a1 1 0 1 1-2 0V10a1 1 0 0 1 1-1m1 4.5a1 1 0 1 0-2 0v.5a1 1 0 1 0 2 0z" />
                </g>
              </svg>
            </div>
            <div class="contentwrapper  ">
              <div class="content-title">
                <b-skeleton v-if="isStatsSkeleton" type="text" width="100px"></b-skeleton>
                <span v-else>Assigned Active Issues</span>
              </div>
              <div class="issueCount clr-title font-weight-bold">
                <b-skeleton v-if="isStatsSkeleton" type="text" width="50px"></b-skeleton>
                <span v-else>{{ activeIssues }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6 mb-3">
          <div class="ticket_card closed-issue-card d-flex align-items-center gap-3 h-100">
            <div class="iconwrapper d-flex align-items-center justify-content-center flex-shrink-0">
              <b-skeleton v-if="isStatsSkeleton" type="circle" width="46px" height="46px" class="rounded-circle"></b-skeleton>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="4">
                  <path stroke-linejoin="round"
                    d="M9 16L34 6l4 10M4 16h40v6c-3 0-6 2-6 5.5s3 6.5 6 6.5v6H4v-6c3 0 6-2 6-6s-3-6-6-6z" />
                  <path d="M17 25.385h6m-6 6h14" />
                </g>
              </svg>
            </div>
            <div class="contentwrapper">
              <div class="content-title">
                <b-skeleton v-if="isStatsSkeleton" type="text" width="100px"></b-skeleton>
                <span v-else>Assigned Closed Issues</span>
              </div>
              <div class="issueCount clr-title font-weight-bold">
                <b-skeleton v-if="isStatsSkeleton" type="text" width="50px"></b-skeleton>
                <span v-else>{{ closedIssues }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6 mb-3">
          <div class="ticket_card open-issue-card d-flex align-items-center gap-3 h-100">
            <div class="iconwrapper d-flex align-items-center justify-content-center flex-shrink-0">
              <b-skeleton v-if="isStatsSkeleton" type="circle" width="46px" height="46px" class="rounded-circle"></b-skeleton>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 640 512">
                <path fill="currentColor"
                  d="M144 160a80 80 0 1 0 0-160a80 80 0 1 0 0 160m368 0a80 80 0 1 0 0-160a80 80 0 1 0 0 160M0 298.7C0 310.4 9.6 320 21.3 320h214c-26.6-23.5-43.3-57.8-43.3-96c0-7.6.7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7h-42.7C47.8 192 0 239.8 0 298.7M320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96m65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.4C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7h300.6c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2l-.1-.2l-2.4-4.1l-.1-.2l-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5v-4.6l-2.7-1.5zM533.3 192h-42.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5.9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3.6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3.7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4.5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8.5 14.3 6.8 17.9l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9V492c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM472 384a40 40 0 1 1 80 0a40 40 0 1 1-80 0" />
              </svg>
            </div>
            <div class="contentwrapper">
              <div class="content-title">
                <b-skeleton v-if="isStatsSkeleton" type="text" width="100px"></b-skeleton>
                <span v-else>Created by me</span>
              </div>
              <div class="issueCount clr-title font-weight-bold">
                <b-skeleton v-if="isStatsSkeleton" type="text" width="50px"></b-skeleton>
                <span v-else>{{ createdByMe }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ticket-card mt-3 p-3 ticket-list-wrapper member_detail">

        <b-card no-body>
          <b-tabs card v-model="tabIndex">
            <b-tab title="Created by me" :disabled="isTabOneDisabled" @click="activeInactiveTab('isTabTwoDisabled', true)">
              <ticket-listing v-if="tabIndex === 0" :tabIndex="tabIndex" @enableNextTab="activeInactiveTab('isTabTwoDisabled', false)" />
            </b-tab>
            <b-tab title="Assigned to me" :disabled="isTabTwoDisabled" @click="activeInactiveTab('isTabOneDisabled', true)">
              <ticket-listing v-if="tabIndex === 1" :tabIndex="tabIndex" @enableNextTab="activeInactiveTab('isTabOneDisabled', false)" @loadStats="getStats()" />
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
      </div>
    </div>
    <AddTicketModal v-if="isAddTicket" />
  </div>
</template>
<script>
import TicketListing from "./partials/TicketListing.vue";
import AddTicketModal from "./modal/AddTicketModal.vue";
import Api from "@/resource/Api";
import EventBus from "@/main";

export default {
  name: "Ticketing",
  components: {
    AddTicketModal,
    TicketListing,
  },
  data() {
    return {
      tabIndex:0,
      canCompose: true,
      showMessage: null,
      selected: null,
      messages: {},
      breadcrumbItems: [{ title: "Ticketing", active: true }],
      users: [],
      rows: [],
      row: null,
      totalIssues: 0,
      activeIssues: 0,
      closedIssues: 0,
      createdByMe: 0,
      isAddTicket: false,
      isStatsSkeleton: false,
      isTabOneDisabled: false,
      isTabTwoDisabled: true,
    };
  },
  computed: {
    filters() {
      const email = this.$store.getters.groupEmail;
      return {
        email: email,
        user_type: "G",
      };
    },
  },
  methods: {
    openModal(modalId) {
      this.isAddTicket = true;
      this.$nextTick(() => {
        this.$bvModal.show(modalId);
      })
    },
    activeInactiveTab(tabType, status) {
      this[tabType] = status;
    },
    getStats() {
      this.isStatsSkeleton = true;
      Api.get('tickets/stats')
        .then((response) => {
          if (response.data.status == "success") {
            const stats = response.data.data;
            this.totalIssues = stats.total_issues;
            this.activeIssues = stats.open_issues;
            this.closedIssues = stats.closed_issues;
            this.createdByMe = stats.created_by_me;
          }
        })
        .catch((error) => {
          console.error('Stats API Error:', error);
        })
        .finally(() => {
          this.isStatsSkeleton = false;
        })
    },

  },
  created() {
    this.getStats();
    EventBus.$on("load-ticket-list", () => this.getStats());
  },
  beforeDestroy() {
    EventBus.$off("load-ticket-list", this.getStats);
  }
};
</script>
<style
  src="@/assets/css/group_dashboard/admin_message_center.css"
  scoped
></style>
<style src="@/assets/css/group_dashboard/ticket_manage.css" ></style>
<style>
.ticket-pagination{
  padding: 0 4px;
}
.ticket-pagination .page-link{
  padding: 0.5rem 0.5rem !important;
}
</style>
